import React, { useState } from "react";

export default function KesariPortal() {
	const [formData, setFormData] = useState({
		description: "",
		file: null,
	});

	const handleChange = (e) => {
		const { name, value, files } = e.target;

		if (name === "file") {
			setFormData({ ...formData, file: files[0] });
		} else {
			setFormData({ ...formData, [name]: value });
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		if (!formData.description) {
			alert("Please fill out this field.");
			return;
		}

		console.log(formData);
	};

	return (
		<div style={{ padding: "0 0 24px 0" }}>
			{/* Header */}
			<div style={{ display: "flex", justifyContent: "space-between" }}>
				<h2>केसरी पोर्टल</h2>
				<div style={{ color: "#6c757d" }}>
					सांगली जिल्हा परिषद / केसरी पोर्टल
				</div>
			</div>

			{/* Card */}
			<div
				style={{
					background: "#fff",
					padding: 20,
					borderRadius: 6,
					marginTop: 10,
					boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
				}}
			>
				{/* Top Instruction */}
				<p style={{ color: "red", textAlign: "center", fontSize: 18 }}>
					केसरी अपलोड करण्याआधी आपले स्टेटस डिटेल्स चेक करावेत.
				</p>

				<form onSubmit={handleSubmit}>
					{/* Description */}
					<div style={{ marginBottom: 20 }}>
						<label style={{ fontWeight: 600 }}>
							Description <span style={{ color: "red" }}>*</span>
						</label>

						<textarea
							name="description"
							value={formData.description}
							onChange={handleChange}
							placeholder="कृपया आपली समस्या येथे प्रविष्ट करा"
							style={{
								width: "100%",
								padding: 10,
								marginTop: 5,
								border: "1px solid #ccc",
								borderRadius: 4,
								height: 80,
							}}
							required
						/>
					</div>

					{/* File Upload + Side Text */}
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: 30,
							marginBottom: 20,
						}}
					>
						<div>
							<label style={{ fontWeight: 600 }}>File</label>
							<br />
							<input
								type="file"
								name="file"
								onChange={handleChange}
								style={{
									marginTop: 5,
									padding: 6,
									border: "1px solid #ccc",
									borderRadius: 4,
								}}
							/>
						</div>

						<div style={{ color: "red", fontSize: 16 }}>
							कृपया ज्या कोणत्याही समस्यांचा सामना करत आहेत, त्याचा
							स्क्रीनशॉट काढा आणि येथे अपलोड करा.
						</div>
					</div>

					{/* Submit */}
					<button
						type="submit"
						style={{
							background: "#5c6ac4",
							color: "white",
							padding: "8px 18px",
							border: "none",
							borderRadius: 4,
							cursor: "pointer",
						}}
					>
						Submit
					</button>
				</form>
			</div>
		</div>
	);
}